// src/components/confirmModal/confirmModal.js
import React from "react";
import { Button, Modal } from "antd";
import "./confirmModal.css";

const ACTION_CONFIG = {
  approve: {
    title: "Confirm Approval",
    message: "Are you sure you want to approve this {entity}?",
    buttonText: "Approve",
    danger: false
  },
  unapprove: {
    title: "Confirm Unapproval",
    message: "Are you sure you want to unapprove this {entity}?",
    buttonText: "Remove",
    danger: false
  },
  delete: {
    title: "Confirm Deletion",
    message: "Are you sure you want to delete this {entity}?",
    buttonText: "Delete",
    danger: true
  },
  block: {
    title: "Confirm Block",
    message: "Are you sure you want to block this {entity}?",
    buttonText: "Block",
    danger: true
  },
  unblock: {
    title: "Confirm Unblock",
    message: "Are you sure you want to unblock this {entity}?",
    buttonText: "Unblock",
    danger: false
  }
};

function ConfirmModal({ open, action = "approve", entity = "item", loading = false, onConfirm, onCancel, customTitle, customMessage, customButtonText }) {
  const config = ACTION_CONFIG[action] || {
    title: "Confirm Action",
    message: "Are you sure you want to perform this action on {entity}?",
    buttonText: "Confirm",
    danger: false
  };

  const title = customTitle || config.title;

  const message = customMessage || config.message.replace("{entity}", entity);

  const buttonText = customButtonText || config.buttonText;

  return (
    <Modal
      open={open}
      title={title}
      centered
      onCancel={onCancel}
      footer={[
        <Button className="cmodal-cancel-btn" key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button
          className={action === "delete" || action === "block" ? "cmodal-danger-btn" : "cmodal-confirm-btn"}
          key="confirm"
          type="primary"
          danger={config.danger}
          loading={loading}
          onClick={onConfirm}
        >
          {buttonText}
        </Button>
      ]}
    >
      <p>{message}</p>
    </Modal>
  );
}

export default ConfirmModal;
